import React from "react";
import { Icon } from "../icons";
import "./formPage.scss";

interface FormPageProps {
    pageTitle?: string;
    pageSubTitle?: string;
    pageDescription?: string;
    className?: string;
}

export const FormPage = (props: React.PropsWithChildren<FormPageProps>) => {
    return (
        <div className={`card-page-wrapper ${props?.className ?? ''}`}>
            {props?.pageTitle && (
                <h3 className="card-page-title">
                    {props.pageTitle}
                </h3>
            )}
            {props?.pageSubTitle && (
                <h4 className="card-page-subtitle">{props.pageSubTitle}</h4>
            )}
            {props?.pageDescription && (
                <p className="card-page-description">{props.pageDescription}</p>
            )}
            {props.children}
        </div>
    )
}